var map = {
	"./additionalproduct_charge_logo.png": "3181",
	"./alphaexpress_charge_logo.png": "12b7",
	"./aramex_charge_logo.png": "b654",
	"./bee_charge_logo.png": "d21c",
	"./bestexpress_charge_logo.png": "81fb",
	"./cjlogistics_charge_logo.png": "b82b",
	"./cod_charge_logo.png": "6423",
	"./deliveree_charge_logo.png": "1d3e",
	"./dhl_charge_logo.png": "201a",
	"./ems_charge_logo.png": "d008",
	"./ems_logo.png": "d573",
	"./flash_charge_logo.png": "c266",
	"./grab_charge_logo.png": "aedd",
	"./interexpress_charge_logo.png": "923c",
	"./jtexpress_charge_logo.png": "ca33",
	"./jwdchilled_charge_logo.png": "d305",
	"./jwdforzen_charge_logo.png": "2862",
	"./jwdfrozen_charge_logo.png": "af4a",
	"./kerry1d_charge_logo.png": "61f6",
	"./kerry2d_charge_logo.png": "8210",
	"./kerry_charge_logo.png": "9fab",
	"./kerry_logo.png": "6088",
	"./lalamove_charge_logo.png": "6a09",
	"./lineman_charge_logo.png": "efa0",
	"./nikos_charge_logo.png": "ee62",
	"./nim_charge_logo.png": "e883",
	"./ninjavan_charge_logo.png": "c9d2",
	"./normal_charge_logo.png": "0a77",
	"./other3_charge_logo.png": "cc54",
	"./other_charge_logo.png": "7d04",
	"./scgexpress_charge_logo.png": "d9ed",
	"./shippopchilled_charge_logo.png": "b6a2",
	"./shippopexpress_charge_logo.png": "d18d",
	"./skootar_charge_logo.png": "8d08",
	"./thailandpost_logo.png": "3946",
	"./tnt_charge_logo.png": "b265",
	"./true_charge_logo.png": "0a86",
	"./zto_charge_logo.png": "5fd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b69b";